export const phone = {
  mask: '+7 915 176 68 25',
  link: 'tel:+79151766825'
}

export const mail = {
  mask: 'mail@chiedohome.com',
  link: 'mailto:mail@chiedohome.com'
}

export const url = 'https://chiedohome.com'

export const worktime = {
  weekdays: 'Будни с 8:00 до 17:00',
  weekends: 'Выходные с 11:00 до 15:00',
  mask: 'в будни с 8:00 до 17:00 или в выходные с 11:00 до 15:00'
}

export const addresses = [
  {
    name: 'Склад в Москве',
    address: 'Москва, Сормовский проезд, 7А',
    worktime: ['Пн-Чт: с 9:00 до 17:00 (мск)', 'Пт: с 9:00 до 16:00 (мск)'],
    coords: [55.709348, 37.798161]
  }
]

export const contacts = [
  {
    title: 'Telegram',
    link: 'https://t.me/Chiedocover_tgbot',
    mod: 'tg'
  }
]
